import { getCookie, getLocalLanguage, setCookie } from '@/utils/index'
import { setLocalStorage, getLocalStorage, removeLocalStorage } from "@/utils/storage";

const TokenKey = 'ACCESS_TOKEN'
const SettingKey = 'USER_SETTING'
const UserKey = 'USER_INFO'
const LoginTime = 'loginTime'
const TenantKey = 'TENANTNAME' 
export function getToken() {
  const token = getCookie(TokenKey)
  if (token) { // 回写本地缓存
    setToken(token)
  }
  return token ? token : getLocalStorage(TokenKey)
}

export function setToken(token: any) {
  setLocalStorage(TokenKey, token)
  setCookie(TokenKey, token, 1)
}

export function removeToken() {
  removeLocalStorage(TokenKey)
  setCookie(TokenKey, '', -1)
}

// setting
export function getSetting() {
  return getLocalStorage(SettingKey)
}

export function saveSetting(settings: any) {
  setLocalStorage(SettingKey, settings)
}

export function removeSetting() {
  removeLocalStorage(SettingKey)
}

// user
export function getUserInfo() {
  let info = getCookie(UserKey)
  if (info) {
    return JSON.parse(info)
  }
  return getLocalStorage(UserKey) ? getLocalStorage(UserKey) : {}
}

// user
export function getTenantInfo() {
  let info = getCookie(TenantKey)
  if (info) {
    return JSON.parse(info)
  }
  return getLocalStorage(TenantKey) ? getLocalStorage(TenantKey) : {}
}

export function setUserInfo(info: any) {
  setLocalStorage(UserKey, info)
  setCookie(UserKey, JSON.stringify(info), 1)
}

export function removeUserInfo() {
  removeLocalStorage(UserKey)
  setCookie(UserKey, '', -1)
}

export function clearAll() {
  localStorage.clear()
}

export function getLoginTime() {
  const loginTime = getCookie(LoginTime)
  if (loginTime) {
    return Number(loginTime)
  }
  return Number(getLocalLanguage(LoginTime))
}

export function setLoginTime(time) {
  setCookie(LoginTime, time, 1)
  setLocalStorage(LoginTime, time)
}
